import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { SplitText } from 'gsap/SplitText';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';
// import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
gsap.registerPlugin(ScrollTrigger);// eslint-disable-line
// gsap.registerPlugin(SplitText);// eslint-disable-line
// gsap.registerPlugin(ScrollSmoother);// eslint-disable-line
// gsap.registerPlugin(MorphSVGPlugin);// eslint-disable-line
// import LocomotiveScroll from 'locomotive-scroll';
// common import css
// import 'locomotive-scroll/dist/locomotive-scroll.css';




export default function sclactSugi() {

  // 開発時にはコメントアウト
  gsap.config({
    nullTargetWarn: false,
  });




  // const locoScroll = new LocomotiveScroll({// eslint-disable-line
  //   el: document.querySelector('[data-scroll-container]'),
  //   smooth: true,
  // });

  document.addEventListener('DOMContentLoaded', () => {

    gsap.utils.toArray(".js--topOR").forEach(function(document) {
      const aniTopOrYellow = document.querySelectorAll('.or-yellow');
      const aniTopOrRed = document.querySelectorAll('.or-red');
      const aniTopOrBlue = document.querySelectorAll('.or-blue');
      const aniTopOrGreen = document.querySelectorAll('.or-green');

      let tlSclTopOr = gsap.timeline({
        scrollTrigger: {
          trigger: document,
          // scrub: true,
          // start: "top center",
          // end: "top 50%",
          once:true,
          // markers: true
        }
      });
      tlSclTopOr.from(aniTopOrYellow, {
        autoAlpha: 0,
        y:100,
        duration: 1,
        ease: "power4.out"
      })
        .from(aniTopOrRed, {
          autoAlpha: 0,
          y:100,
          duration: 1,
          ease: "power4.out"
        },"-=.5")
        .from(aniTopOrBlue, {
          autoAlpha: 0,
          y:100,
          duration: 1,
          ease: "power4.out"
        },"-=.5")
        .from(aniTopOrGreen, {
          autoAlpha: 0,
          y:100,
          duration: 1,
          ease: "power4.out"
        },"-=.5");
    });


    gsap.utils.toArray(".js--topFeature").forEach(function(document) {
      const aniTopFea = document.querySelectorAll('.js--topFeaItem');
      const aniTopFeaBox = document.querySelectorAll('.js--topFeaItem--box');
      const aniTopFeaBoxTTL = document.querySelectorAll('.js--topFeaItem--box--ttl');
      const aniTopFeaBoxTXT = document.querySelectorAll('.js--topFeaItem--box--txt');

      let tlaniTopFea = gsap.timeline({
        scrollTrigger: {
          trigger: document,
          // scrub: true,
          start: "top 75%",
          end: "+=500",
          // markers: true
        }
      });
      tlaniTopFea
        .from(aniTopFea, {
          autoAlpha: 0,
          y:200,
          duration: 2,
          ease: "power4.out"
        })
        .from(aniTopFeaBox, {
          autoAlpha: 0,
          y:120,
          duration: .5,
          ease: "power4.out"
        },"-=1.75")
        .from(aniTopFeaBoxTTL, {
          autoAlpha: 0,
          y:80,
          duration: .5,
          ease: "power4.out"
        },"-=1.5")
        .from(aniTopFeaBoxTXT, {
          autoAlpha: 0,
          y:80,
          duration: .5,
          ease: "power4.out"
        },"-=1.5");
    });


    gsap.utils.toArray(".js--sndFeature").forEach(function(document) {
      const aniSndFea = document.querySelectorAll('.js--sndFeaItem');
      const aniSndFeaBox = document.querySelectorAll('.js--sndFeaItem--box');
      const aniSndFeaBoxTXT = document.querySelectorAll('.js--sndFeaItem--box--txt');

      let tlaniSndFea = gsap.timeline({
        scrollTrigger: {
          trigger: document,
          // scrub: true,
          start: "top 75%",
          end: "+=500",
          // markers: true
        }
      });
      tlaniSndFea
        .from(aniSndFea, {
          autoAlpha: 0,
          y:200,
          duration: 2,
          ease: "power4.out"
        })
        .from(aniSndFeaBox, {
          autoAlpha: 0,
          y:120,
          duration: 1.5,
          ease: "power4.out"
        },"-=1")
        .from(aniSndFeaBoxTXT, {
          autoAlpha: 0,
          y:120,
          duration: 1.5,
          ease: "power4.out"
        },"-=1");
    });

  });

}